import Route from '@ember/routing/route';
import protectedRoute from 'lumen/utils/decorators/protected-route';

type Params = {
  my_explore: string;

  my_model: string;
};

// @ts-expect-error: Unable to resolve signature of class decorator when called as an expression.
@protectedRoute({
  features: ['business_intelligence.custom_reporting.edit'],
  redirectTo: 'market.custom-reporting.index',
})
export default class MarketCustomReportingExploreRoute extends Route {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model({ my_model: modelName, my_explore: exploreName }: Params) {
    return { modelName, exploreName };
  }
}
